
<!--
  版本更新
-->
<template>
<div class="versionInfo">
  <div class="top clearfix">
    <div class="page-title top0 fl">版本更新</div>
    <el-button @click="operationVersion('add')" class="fr" type="primary" size="medium" icon="iconfont icon-tianjia-copy">新建版本</el-button>
  </div>
  <div class="tableBox">
    <el-table :data="versionList" v-loading="listLoading" border stripe style="width:100%">
      <el-table-column width="240"
        prop="versionNumber"
        label="版本号">
      </el-table-column>
      <el-table-column
        prop="versionExplain"
        label="更新说明">
        <template slot-scope="scope">
          <div class="explain-box">{{scope.row.versionExplain}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <div class="edit">
            <el-button border @click="operationVersion('edit',scope.row)">编辑</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging-box" v-if="pageTotal>0">
      <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[ 10, 20, 40, 80, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
  <el-dialog
    :title="operationVersionTitle+'版本信息'"
    :visible="operationVersionVisible"
    @close="btnCancel()"
    :close-on-click-modal="false"
    width="580px">
    <el-form ref="operationVersionRef" :model="operationVersionForm" :rules="operationVersionRules" label-width="100px">
      <el-form-item prop="versionNumber" label="版本号：">
        <el-input v-model="operationVersionForm.versionNumber" placeholder="请输入版本号"></el-input>
      </el-form-item>
      <el-form-item prop="instructions" label="更新说明：" style="margin-bottom:0;">
        <el-input v-model="operationVersionForm.instructions" type="textarea" :autosize="{ minRows:5, maxRows: 15 }" placeholder="请输入更新说明"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="btnCancel()">取 消</el-button>
      <el-button type="primary" size="medium" @click="versionSubmit">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>
<script>
// 表单验证
import { notNullable } from '@/components/form/formValidation'

export default {
  // 组件名称
  name: 'versionInfo',
  // 组件状态值
  data() {
    // 版本号验证
    const validationVersionNumber = async (rule, value, callback) => {
      if (this.versionNumberList.indexOf(value) !== -1) {
        return callback(new Error('版本号不可重复'))
      } else {
        callback()
      }
    }
    return {
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      listLoading: false,
      versionList: [],
      operationVersionTitle: '',
      operationVersionVisible: false,
      operationVersionForm: {
        versionNumber: '',
        instructions: ''
      },
      operationVersionRules: {
        versionNumber: [notNullable('版本号'), { validator: validationVersionNumber, trigger: ['change', 'blur'] }],
        instructions: [notNullable('更新说明')]
      },
      editId: 0,
      requestUrl: '',
      versionNumberAllList: [],
      versionNumberList: []
    }
  },
  watch: {
    operationVersionVisible(to, form) {
      if (!to) {
        this.$refs.operationVersionRef.resetFields()
        this.editId = 0
        this.versionNumberList = []
      }
    }
  },
  mounted() {
    this.getVersionList()
  },
  methods: {
    getVersionList() {
      this.listLoading = true
      this.getVersionNumber()
      this.$service.post('/api/system/messages/list', {
        'pageNum': this.currentPage,
        'pageSize': this.pagesize
      }).then(res => {
        this.versionList = res.result.pageData
        this.pageTotal = res.result.pageTotal
        this.listLoading = false
      }).catch(Err => {
        this.listLoading = false
      })
    },
    getVersionNumber() {
      this.$service.post('/api/system/messages/number').then(res => {
        this.versionNumberAllList = res.result
      }).catch(Err => {
      })
    },
    operationVersion(type, row) {
      console.log('operationVersion', type, row)
      this.versionNumberList = JSON.parse(JSON.stringify(this.versionNumberAllList))
      if (type === 'add') {
        this.operationVersionTitle = '新建'
        this.requestUrl = '/api/system/messages/save'
      } else {
        this.operationVersionTitle = '编辑'
        this.requestUrl = '/api/system/messages/edit'
        this.$nextTick(() => {
          this.editId = row.id
          this.versionNumberList = this.versionNumberList.filter(item => item !== row.versionNumber)
          this.$set(this.operationVersionForm, 'versionNumber', row.versionNumber)
          this.$set(this.operationVersionForm, 'instructions', row.versionExplain)
        })
      }
      this.operationVersionVisible = true
    },
    versionSubmit() {
      this.$refs.operationVersionRef.validate(valid => {
        if (valid) {
          let param = {
            'id': this.editId,
            'versionExplain': this.operationVersionForm.instructions,
            'versionNumber': this.operationVersionForm.versionNumber
          }
          this.$service.post(this.requestUrl, param).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.operationVersionVisible = false
            this.getVersionList()
          }).catch(Err => {
            this.operationVersionVisible = false
          })
        }
      })
    },
    btnCancel() {
      this.operationVersionVisible = false
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.pagesize = size
      this.getVersionList()
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getVersionList()
    }
  }
}
</script>

<style lang="less">
  @import './../../styles/common/public.less';
  .versionInfo{
    .tableBox{
      .explain-box{
        white-space: pre-line;
        text-align:left;
        line-height:22px;
        padding:10px 5px;
      }
      .el-button{
        color: @color;
        background: none;
        border: 0;
        &:hover{
          color: @colorHover;
        }
      }
    }
    .el-dialog__wrapper{
      .el-input,.el-textarea{
        width: 440px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/operationManage/versionInfo.vue